import { ApiUtil } from '../../apis/live/ApiUtil';
import { setNoticeLocale } from '../show-notice';
import { LiveErrorUtils } from './LiveErrorUtils';
export function createErrorUtils(errorUtilsModuleName, environment, createAnalyticsEvent) {
  var showFlag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {
    return function () {};
  };
  return new LiveErrorUtils(errorUtilsModuleName, showFlag, createAnalyticsEvent, environment);
}
export function createUtils(settings, errorUtilsModuleName, showFlag, createAnalyticsEvent, locale) {
  var errorUtils = new LiveErrorUtils(errorUtilsModuleName, showFlag, createAnalyticsEvent, settings.environment);
  setNoticeLocale(locale);
  var apiUtil = new ApiUtil(settings.urls.jira, settings.urls.api, errorUtils, createAnalyticsEvent);
  return {
    apiUtil: apiUtil,
    errorUtils: errorUtils
  };
}

// Same as createUtils above but we separate out the parts of the settings object that we want as separate parameters
export function createUtils2(jiraUrl, apiUrl, environment, errorUtilsModuleName, showFlag, createAnalyticsEvent, locale) {
  var errorUtils = new LiveErrorUtils(errorUtilsModuleName, showFlag, createAnalyticsEvent, environment);
  setNoticeLocale(locale);
  var apiUtil = new ApiUtil(jiraUrl, apiUrl, errorUtils, createAnalyticsEvent);
  return {
    apiUtil: apiUtil,
    errorUtils: errorUtils
  };
}